module.exports = __webpack_public_path__ + "static/media/plus-circle-sm-light.311eba44.svg";